module.exports = __webpack_public_path__ + "media/images/logo-1dfd694643405876923c9f4de4e8e2a8.png";